export default __webpack_public_path__ + "static/media/8.a46c5930.jpeg";